import React from "react";
import './AboutBlock.scss';
import { Container, Row, Col } from "react-bootstrap";

function AboutBlock() {
    return (
        <div className="about-block" id="about">
            <Container className="about-container mb-5">
                <Row className="align-items-center gy-4">
                    <Col xs={12} md={5}>
                        <div className="about-img"></div>
                    </Col>
                    <Col xs={12} md={7}>
                        <div className="text-block">
                            <h3>{"Об олимпиаде"}</h3>
                            <p>
                                Международная олимпиада имени В. И. Даля — культурно-просветительский проект, посвящённый популяризации русского языка. Мероприятие приурочено к 225-летию со дня рождения писателя и лексикографа.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container className="about-list-container">
                <Row className="gy-4 justify-content-center align-items-stretch">

                    <Col xs={12} md={6} lg={4}>
                        <div className="about-item h-100">
                            <div className="about-item-up">
                                <div className="title">{`Направления`}</div>
                                <div className="about-item-icon icon1"></div>
                            </div>
                            <div className="about-item-down">
                                <div className="list">
                                    {`• «Русский как иностранный (РКИ)» \n• «Русский язык обучения»`}
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                        <div className="about-item h-100">
                            <div className="about-item-up">
                                <div className="title">{`Формат проведения`}</div>
                                <div className="about-item-icon icon2"></div>
                            </div>
                            <div className="about-item-down">
                                <div className="list">
                                    {`• Отборочный этап – \nонлайн-формат\n• Заключительный этап –\nонлайн-формат`}
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                        <div className="about-item h-100">
                            <div className="about-item-up">
                                <div className="title">{`Категории участников`}</div>
                                <div className="about-item-icon icon3"></div>
                            </div>
                            <div className="about-item-down">
                                <div className="list">
                                    {`• 7-9 класс\n• 12-16 лет`}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

        </div>
    );
}

export default AboutBlock;
